import { useEffect, useState } from "react";

import {
  Box,
  CircularProgress,
  Grid,
  Link,
  Button as MUIButton,
  Typography,
} from "@mui/material";

import {
  isChrome,
  isEdge,
  isFirefox,
  isIE,
  isMobile,
  isSafari,
} from "react-device-detect";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { endPoints, sportEndPoint } from "../../constant/Environment";
import "../../css/main.css";
import noplayer from "../../image/empty2.png";
import { Actions } from "../../redux/Actions/Actions";
import "../../screens/Sportsbook/Sportsbook.css";
import { addBetData, getAllData, RemovePlayer } from "../../Utility/API";
import { checkGeoAndVpn, formatAmount } from "../../Utility/functions/Helper";
import GeoVpnError from "../GeoVpnError";
import BetslipPayout from "../BetslipPayout";
import Toaster from "../Toast";
import { ErrorToast, SuccesToast } from "../Toast/message";
import BetslipHeader from "./BetslipHeader";
import BetslipWarnings from "./BetslipWarnings";
import ConfirmReceipt from "./ConfirmReceipt";
import PlayerCardItem from "./PlayerCardItem";
var betSlipRefresh = [];

var geoClient = null;

const MultiPlayerBetSlip = (props) => {
  const [warningMsg, setWarningMsg] = useState(false);
  const [showGeoVpnError, setShowGeoVpnError] = useState(false);
  const [showbtn, setShowbtn] = useState(true);
  const navigate = useNavigate();
  const state = useSelector((state) => state);
  const [up, setup] = useState(false);
  const [down, setdown] = useState(false);
  const [card, setcard] = useState([]);
  const [apidata, setApidata] = useState([]);
  const [newvalue, setnewvalue] = useState("");
  const [visible, setvisible] = useState(state?.betslip.isVisible);
  const [isloading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [entry, setentry] = useState(1);
  const [playerlength, setplayerlength] = useState(1);
  const [display, setdisplay] = useState(
    localStorage.getItem("display") || true
  );
  const [err, seterr] = useState(true);
  const [start, setStart] = useState(false);
  const dispatch = useDispatch();
  const [checklength, setchecklength] = useState(
    parseInt(localStorage.getItem("length")) || 0
  );
  const [samesport, setSamesport] = useState(false);
  const [sameteaminfo, setsameTeamInfo] = useState(false);
  const [restrictplayer, setRestrictplayer] = useState(false);
  const [show, setShow] = useState(true);
  const [loginbtn, setloginbtn] = useState(true);
  const [Couponid, setCouponId] = useState("");
  const [coupons, setCoupons] = useState([]);
  const [selectedCoupons, setSelectedCoupons] = useState(null);
  const [sameTeam, SetsameTeam] = useState(false);
  const [multiplierResponse, setMultiplierResponse] = useState([]);
  const [betMaxValue, setBetMaxValue] = useState(1);
  const { auth } = state;
  let visibility = state?.betslip.isVisible;
  let betslipLength = state.betslip.betslips.length;
  let showerror = state?.betslip.Message;
  let betslipData = state.betslip.betslips;
  betSlipRefresh = betslipData;
  const { isVpn, isUserInAllowedRegion } = state?.auth;

  let teamchk = state?.betslip.isteam;

  let statchk = state?.betslip.isStatchk;

  let deviceId = "web";

  let operatingPlatform = navigator.platform;

  let browsername = window.navigator;

  const sameSport = state?.betslip?.sameSport;

  function devicetype() {
    if (isMobile) return "Mobile web";
    else return "web";
  }

  function BrowserInfo() {
    if (isChrome) return "Google Chrome";
    if (isFirefox) return "Mozilla Firefox";
    if (isSafari) return "Apple Safari";
    if (isEdge) return "Microsoft Edge";
    if (isIE) return "Internet Explorer";
    return "Unknown Browser";
  }

  const naviagte3 = () => {
    dispatch({
      type: Actions.TEST_CASE,
      data: false,
    });
    navigate("/userwallet");
  };

  const GetUserById = () => {
    let url = `${endPoints.api.GET_BY_USERID}/${auth?.user?.idUser}`;
    getAllData(url).then((response) => {
      dispatch({
        type: Actions.LOGIN,
        data: { user: response.data },
      });
    });
  };

  const howtoplay = () => {
    dispatch({
      type: Actions.TEST_CASE,
      data: false,
    });
    navigate("/how-to-play");
  };

  const fantasypts = () => {
    dispatch({
      type: Actions.TEST_CASE,
      data: false,
    });
    navigate("/scoring");
  };

  const handleCheckboxChange = (coupon) => (event) => {
    if (event.target.checked) {
      setSelectedCoupons(coupon.id_coupon);
      setnewvalue(coupon.amount);
    } else {
      setSelectedCoupons(null);
      setnewvalue("");
    }
  };

  const getcoupons = () => {
    if (state?.auth?.user?.idUser) {
      let url = `${endPoints.api.GET_ALL_COUPONS}/${state?.auth?.user?.idUser}`;
      getAllData(url).then((response) => {
        const result = response?.data;
        // console.log("result",result);
        if (response.status == "success") {
          setCoupons(result);
        }
      });
    }
  };

  useEffect(() => {
    getcoupons();
  }, []);

  const filteredCoupons = coupons.filter((coupon) => {
    if (coupon?.player_type === 1 && betslipLength === coupon?.player_count) {
      return true; // Fixed team size
    }
    if (coupon?.player_type === 2 && betslipLength >= coupon?.player_count) {
      return true; // Min team size
    }
    return false;
  });

  useEffect(() => {
    setSelectedCoupons(null);
  }, [betslipLength]);

  useEffect(() => {
    if (selectedCoupons === null) {
      setnewvalue("");
    }
  }, [selectedCoupons]);

  let isMoreValidation = [];
  let userverification = state?.auth?.user?.validation;

  const data = JSON.parse(localStorage.getItem("user"));
  let nation = state?.auth?.user?.nation;
  let userid = state?.auth?.user?.idUser;
  let sessionid =
    state?.auth?.user?.sessionId || localStorage.getItem("session");
  let balance =
    state.auth.isAuthenticated === false
      ? 0
      : state?.auth?.user?.account?.ubalance;

  let mainwalletbalance =
    state.auth.isAuthenticated === false
      ? 0
      : Number(
          state?.auth?.user?.account?.totalBalance?.replace(/[^0-9.-]+/g, "")
        );

  let accountid =
    state?.auth?.isAuthenticated === false
      ? state?.auth?.user?.accountid
      : state?.auth?.user?.account?.idAccount;

  let minvalue = Number(state?.betslip?.betConfiguration?.min_wager);
  let maxvalue = Number(state?.betslip?.betConfiguration?.max_wager);
  let isSelected = state?.betslip?.isSelected;
  let date = new Date();

  const MaximumWin = Number(state?.betslip?.betConfiguration?.max_win);

  let pastdatewarning = state?.betslip?.dateMsg;

  const minMultiplier = Number(state?.betslip?.betConfiguration?.min_multiplier); 

  const handleRemoveBetslip = (index) => {
    dispatch({
      type: Actions.REMOVE_SELECTED_BETSLIP,
      removeEleIndex: index,
    });
    if (betslipLength <= 2) {
      dispatch({
        type: Actions.PARLAY_BETS,
        data: false,
      });
    }
  };
  const handleRemoveAllBetslips = () => {
    dispatch({
      type: Actions.REMOVE_ALL_BETSLIP,
    });
    dispatch({
      type: Actions.PARLAY_BETS,
      data: false,
    });
  };

  const Maxbet = async (userId, amount, maxvalue) => {
    // e.preventDefault();
    if (state?.auth?.isAuthenticated) {
      let url = `${endPoints.apiBaseUrl}${endPoints.api.BET_TRAKING}`;
      setIsLoading(true);
      let data = {
        id_user: userId,
        amount: amount,
        bet_limit: maxvalue,
        crs_limit: state?.auth?.user?.betLimit?.crs_limit,
        day_limit: state?.auth?.user?.betLimit?.day_limit,
        player_count: state?.betslip?.betslips?.length,
      };
      try {
        let response = await addBetData(url, data);
        setIsLoading(false);
        if (response.data.status == "success") {
          // no action requird only info api
        } else {
        }
      } catch (err) {
        setIsLoading(false);
        console.log("err", err);
      }
    }
  };

  // const betvalue = (e) => {
  //   const regex = /^\d*\.?\d{0,2}$/;
  //   const newValue = e.target.value;
  //   if (regex.test(newValue)) {
  //     if (
  //       newValue === "" ||
  //       newValue === "-" ||
  //       newValue === "-." ||
  //       newValue === ".-" ||
  //       newValue.match(/^([0-9]+\.?[0-9]*|\.[0-9]+)$/)
  //     ) {
  //       setnewvalue(newValue);
  //     }
  //   }
  // };

  // const betvalue = (e) => {
  //   const newValue = e.target.value;

  //   if (/^\d*$/.test(newValue)) {
  //     // clamp with max cap
  //     const num = Number(newValue);
  //     const maxAllowed = maxWager;

  //     if (num > maxAllowed) {
  //       setnewvalue(maxAllowed.toString());
  //     } else {
  //       setnewvalue(newValue);
  //     }
  //   }
  // };

  const betvalue = (e) => {
  let newValue = e.target.value;

  // allow numbers with up to 2 decimal places
  if (/^\d*\.?\d{0,2}$/.test(newValue)) {
    let num = parseFloat(newValue);

    // handle empty input
    if (newValue === "" || isNaN(num)) {
      setnewvalue("");
      return;
    }

    // clamp to maxWager
    if (num > maxWager) {
      setnewvalue(maxWager); // keep 2 decimals
    } else {
      setnewvalue(newValue);
    }
  }
};

  const MultiplierProduct = state.betslip.betslips.reduce(
    (product, player) => product * player?.multiplier,
    1
  );

  const roundedProduct = parseFloat(MultiplierProduct.toFixed(2));

  // const maxWager =
  //   Math.floor(MaximumWin / betMaxValue) > maxvalue
  //     ? maxvalue
  //     : Math.floor(MaximumWin / betMaxValue);

    const maxWager =
     MaximumWin / betMaxValue > maxvalue
    ? maxvalue
    : Math.floor((MaximumWin / betMaxValue) * 100) / 100;


  const handlePayoutUpdate = (values) => {
    // console.log("Got values from BetslipPayout:", values[0].multiplier);
    setBetMaxValue(values[0]?.multiplier);
  };

  const RequiredPlayerData = state.betslip.betslips.map((player) => ({
    sport: player?.sports || 0,
    league: player?.league || 0,
    sportName: player.playerevent?.sport?.name || "",
    leagueName: player.playerevent?.league?.name || "",
    points: player?.points || 0,
    price: player?.price || 0,
    multiplier: player?.multiplier || 1.0,
    finalpoints: 0,
    marketId: player?.marketId || 0,
    marketAbv: player?.statAbv || "",
    eventId: player?.eventId,
    eventStatus: 0,
    eventOJ_ID: player?.oj_ID || "",
    id: player?.playerId, //playerId
    name: player?.name,
    team: player?.team || player.teamName || "",
    position: player?.position || "",
    wager: newvalue,
    isMore: player?.more,
    isLess: player?.less,
    event_time: player?.event_time,
    game_type: player?.game_type,
    single_event: player?.single_event,
    teamA: player?.playerevent?.teamA || "",
    teamH: player?.playerevent?.teamH || "",
    image: player?.image || "",
    playerId: player.id, //player_id
  }));

  let datavalue = {
    platform: "WEB",
    nation: nation,
    userId: userid,
    sessionId: sessionid,
    accountId: accountid,
    context: "string",
    location: state?.auth?.stateInfo?.stateCode || "",
    amount: newvalue,
    sameTeam: sameSport,
    wager: newvalue,
    couponid: selectedCoupons ? selectedCoupons : 0,
    toWin: 0,
    type: "STRAIGHT",
    deviceId: deviceId,
    operatingsystem: operatingPlatform,
    browser: BrowserInfo(),
    device: devicetype(),
    playerData: RequiredPlayerData,
  };

  useEffect(() => {
    setnewvalue("");
  }, [state.betslip.betslips]);

  const betslip = async (event) => {
    event?.preventDefault();

    let url = `${sportEndPoint.apiBaseUrl}${sportEndPoint.api.fantasy}`;
    setIsLoading(true);

    await addBetData(url, datavalue)
      .then((response) => {
        // window.GeoComply.Client.disconnect();
        if (response?.data?.status?.toLowerCase() == "success") {
          setApidata(response?.data?.playerData);
          setIsLoading(false);
          SetsameTeam(response?.data?.sameTeam);
          setentry(response?.data?.wager);
          setMultiplierResponse(response?.data?.payoutDetail);
          setplayerlength(response?.data?.playerData?.length);
          handleRemoveAllBetslips();
          setnewvalue("");
          setchecklength(0);
          GetUserById();
          getcoupons();
          dispatch({
            type: Actions.RECECIPT_VISIBLE,
            data: false,
          });
          setIsLoading(false);
          setWarningMsg(false);
          dispatch({
            type: Actions.DATE_MSG,
            data: false,
          });
          SuccesToast("Your bet has been placed successfully.");
        } else {
          setIsLoading(false);
          if (response.data?.code == 404) {
            setMessage(
              "You are currently logged in on another device. Please login again to continue.  You will be logged out of your other device."
            );
            ErrorToast(
              "You are currently logged in on another device. Please login again to continue.  You will be logged out of your other device."
            );
            dispatch({
              type: Actions.TEST_CASE,
              data: false,
            });

            dispatch({
              type: Actions.LOGOUT,
            });
            dispatch({
              type: Actions.REMOVE_ALL_BETSLIP,
            });
            dispatch({
              type: Actions.PARLAY_BETS,
              data: false,
            });
            sessionStorage.clear();
            window.location.reload();
            navigate("/");
          } else {
            setMessage(response.data.message);
            ErrorToast(response.data.message);
          }
        }
      })
      .catch((error) => {
        setIsLoading(false);
        ErrorToast(
          "Issue connecting to server (error code 15). Please contact support for further assistance."
        );
        console.error(error);
      });
  };

  useEffect(() => {
    localStorage.setItem("display", display);
    localStorage.setItem("length", checklength);
  }, [display, checklength]);

  //logic for slecting player more than 2 stats (should not allow)
  useEffect(() => {
    const playerCounts = {};
    state.betslip.betslips.forEach((item) => {
      const key = `${item.playerId}_${item.eventId}`;

      if (!playerCounts[key]) {
        playerCounts[key] = 1;
      } else {
        playerCounts[key]++;
      }
    });

    let isAnyPlayerSelectedMoreThanTwice = Object.values(playerCounts).some(
      (count) => count > 2
    );

    if (isAnyPlayerSelectedMoreThanTwice == true) {
      dispatch({
        type: Actions.STAT_CHECK,
        data: false,
      });
    } else if (isAnyPlayerSelectedMoreThanTwice == false) {
      dispatch({
        type: Actions.STAT_CHECK,
        data: true,
      });
    }
  }, [state.betslip.betslips]);

  useEffect(() => {
    state?.betslip?.betslips?.map((item) => {
      const sportsname = state?.betslip?.betslips?.map((item) => item?.sports);

      const differentsports = sportsname?.every(
        (item) => item === sportsname[0]
      );

      if (differentsports == true) {
        if (item?.game_type == 1) {
          const teamIds = state?.betslip?.betslips?.map((item) => item?.team);

          const allDifferent = teamIds?.every((item) => item === teamIds[0]);

          if (allDifferent == false) {
            dispatch({
              type: Actions.TEAMCHECK,
              data: true,
            });
          }
        } else if (item?.game_type == 2) {
          dispatch({
            type: Actions.TEAMCHECK,
            data: true,
          });
        }
      } else if (differentsports == false) {
        dispatch({
          type: Actions.TEAMCHECK,
          data: true,
        });
      }
    });
  }, [state.betslip.betslips]);

  useEffect(() => {
    const eventIds = state?.betslip?.betslips?.map((item) => item?.eventId);
    const uniqueEventIds = new Set(eventIds);

    if (uniqueEventIds.size === 1) {
      dispatch({
        type: Actions.SAME_SPORT,
        data: true,
      });
    } else {
      dispatch({
        type: Actions.SAME_SPORT,
        data: false,
      });
    }
  }, [state.betslip.betslips]);

  useEffect(() => {
    state.betslip.betslips.map((item) => {
      const eventIds = state?.betslip?.betslips?.map((item) => item?.eventId);

      const uniqueEventIds = new Set(eventIds);

      if (uniqueEventIds?.size === 1 && eventIds?.length > 6) {
        setRestrictplayer(true);
      } else {
        setRestrictplayer(false);
      }
    });
  }, [state?.betslip?.betslips]);

  const gotologin = () => {
    dispatch({
      type: Actions.TEST_CASE,
      data: false,
    });
    navigate("/login");
  };

  let morelesscount = 0;
  let betvalidation = 0;

  const betsubmit = async () => {
    setIsLoading(true);

    if (state?.auth?.user?.verification == "0") {
      ErrorToast(
        "Please verify your email before you can submit a contest entry."
      );
      setIsLoading(false);
      return; // Stop execution if the user is not verified
    }

    if (statchk) {
      if (teamchk) {
        if (restrictplayer == false) {
          for (let i = 0; i < state.betslip.betslips.length; i++) {
            if (
              state.betslip.betslips[i].more == true ||
              state.betslip.betslips[i].less == true
            ) {
              morelesscount = morelesscount + 1;
              if (morelesscount == betslipLength) {
                betvalidation = 1;
              }
            } else {
              ErrorToast("Please select More or Less for each player.");
              setIsLoading(false);
              return;
            }
          }
        } else {
          ErrorToast(
            "You can not select more than 6 players from the same game. To add more players, please select from another event."
          );
          setIsLoading(false);
          return;
        }
      } else {
        ErrorToast(
          "Please select at least 1 player from another team. Your team cannot consist of all players from the same team."
        );
        setIsLoading(false);
        return;
      }
    } else {
      ErrorToast(
        "Your roster includes more than 2 stats from the same player. You can only add a maximum of 2 stats for each player in your roster. Please update your roster to submit your lineup."
      );
      setIsLoading(false);
      return;
    }

    if (betvalidation == 1) {
      if (datavalue.amount != "") {
        if (
          parseInt(datavalue.amount) <= parseInt(maxvalue) ||
          selectedCoupons
        ) {
          if (
            parseInt(datavalue.amount) >= parseInt(minvalue) ||
            selectedCoupons
          ) {
            if (datavalue.amount <= mainwalletbalance || selectedCoupons) {
              const geoResult = await checkGeoAndVpn(dispatch);

              if (!geoResult) {
                betslip();
              } else {
                setIsLoading(false);
                setShowGeoVpnError(true);
              }
            } else {
              dispatch({
                type: Actions.CLEAR_MSSG,
                data: false,
              });
              setIsLoading(false);
            }
          } else {
            ErrorToast("Minimum entry fee is $" + minvalue);
            setIsLoading(false);
          }
        } else {
          Maxbet(datavalue?.userId, datavalue?.amount, maxvalue);
          ErrorToast(
            "Entry amount exceeds the maximum entry fee of $" + maxvalue
          );
          setIsLoading(false);
        }
      } else {
        ErrorToast("Please submit an entry fee.");
        setIsLoading(false);
      }
    } else {
      // If betvalidation is not equal to 1, stop execution and return
      setIsLoading(false);
      return;
    }
  };

  useEffect(() => {
    dispatch({
      type: Actions.RECECIPT_VISIBLE,
      data: true,
    });
    dispatch({
      type: Actions.CLEAR_MSSG,
      data: true,
    });
  }, []);

  const closeconfirmbox = () => {
    dispatch({
      type: Actions.RECECIPT_VISIBLE,
      data: true,
    });
  };

  // gets odds api call
  // useEffect(() => {
  //   const timer = setInterval(() => {
  //     if (betslipLength > 0) {
  //       CalculateLatestOdds();
  //     }
  //   }, SPORTS.GameTimeOut);
  //   return () => clearInterval(timer);
  // }, [betslipLength]);

  const CalculateLatestOdds = () => {
    let betslip = state.betslip.betslips;

    if (betslipLength > 0) {
      let filterar = [];
      betSlipRefresh.map((item) => {
        filterar.push({
          fixtureId: item.eventId,
          marketId: parseInt(item.marketId),
          name: item.name, //playerrr name  -- > name
          betId: item.playerId,
        });
      });

      let data = {
        bets: filterar,
      };
      let url = `${sportEndPoint.apiBaseUrl}${sportEndPoint.api.Odds_Refresh}`;
      addBetData(url, data)
        .then((response) => {
          if (response?.data?.length > 0) {
            let updated = response.data;
            let old = betSlipRefresh;

            let final = old.map((data, index) => {
              let result = updated.find(
                (item) =>
                  item.betId == data.playerId && item.marketId == data.marketId
              );

              if (
                result.status == 1 &&
                result.odds != data.points &&
                result.marketId == data.marketId &&
                result.eventid == data.eventid
              ) {
                //&&  result.odds != data.points

                dispatch({
                  type: Actions.SELECTED_REFRESH_BETSLIP,
                  fixtureId: result.fixtureId,
                  odds: result.odds,
                  betId: result.betId,
                  marketId: result.marketId,
                });
                setWarningMsg(true);
              } else if (result.odds == data.points && result.status == 1) {
              } else if (result.status == 2) {
                dispatch({
                  type: Actions.REMOVE_SELECTED_BETSLIP,
                  removeEleIndex: index,
                });
                dispatch({
                  type: Actions.DATE_MSG,
                  data: true,
                });
              } else {
                // dispatch({
                //   type: Actions.REMOVE_SELECTED_BETSLIP,
                //   removeEleIndex: index,
                // });
              }
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const Removeplayerapi = (value) => {
    RemovePlayer(
      state?.auth?.user?.idUser || "",
      value.single_event,
      value.name,
      value.single_event,
      value.points,
      value.statAbv
    );
  };
  //	•	and the entry form into EntryForm.jsx.
  return (
    <Box className="col-lg-4" id="side-betslip">
      <Box className="display height-scroll team-divmain">
        <Grid item xs={12} className="mb-1">
          <BetslipHeader
            betslipLength={betslipLength}
            onClearAll={() => {
              handleRemoveAllBetslips();
              setdisplay(true);
              setchecklength(0);
              dispatch({ type: Actions.SELECTED, data: false });
              dispatch({ type: Actions.CLEAR_MSSG, data: true });
              dispatch({ type: Actions.RECECIPT_VISIBLE, data: true });
              dispatch({ type: Actions.TEAMCHECK, data: false });
              dispatch({ type: Actions.DATE_MSG, data: false });
              setWarningMsg(false);
              dispatch({
                type: Actions.SAME_SPORT,
                data: false,
              });
            }}
          />
        </Grid>
        <Grid item xs={12} md={12} className="mb-1" sx={{ py: 1 }}>
          {state.betslip.betslips.map((value, index) => (
            <PlayerCardItem
              // key={`${value?.playerId || index}-${value?.eventId}`}
              key={`${value?.playerId || index}-${value?.eventId}-${value?.marketId}`}
              value={value}
              index={index}
              onRemove={(i, v) => {
                handleRemoveBetslip(i);
                dispatch({ type: Actions.SELECTED, data: false });
                dispatch({ type: Actions.TEAMCHECK, data: false });
                Removeplayerapi(v);
              }}
            />
          ))}

          <ConfirmReceipt
            visibility={visibility}
            apidata={apidata}
            playerlength={playerlength}
            sameTeam={sameTeam}
            entry={entry}
            multiplierResponse={multiplierResponse}
            closeconfirmbox={closeconfirmbox}
          />

          {isloading && (
            <Box className="spintarget">
              <CircularProgress />
            </Box>
          )}

          {state.betslip.betslips.length == 0 && (
            <Box sx={{ display: visibility ? "contents" : "none" }}>
              <Grid item lg={12}>
                <img
                  alt="bettdraft"
                  src={noplayer}
                  style={{ height: "250px", marginLeft: "16%" }}
                />
              </Grid>
            </Box>
          )}
        </Grid>

        <Box
          className="fixed-div"
          sx={{ background: "#E4E4E4", mb: "-10px", pb: "10px" }}
        >
          <BetslipWarnings
            betslipLength={betslipLength}
            visibility={visibility}
            statchk={statchk}
            teamchk={teamchk}
            restrictplayer={restrictplayer}
            warningMsg={warningMsg}
            pastdatewarning={pastdatewarning}
            howtoplay={howtoplay}
            fantasypts={fantasypts}
            userverification={userverification}
            filteredCoupons={filteredCoupons}
            selectedCoupons={selectedCoupons}
            handleCheckboxChange={handleCheckboxChange}
            formatAmount={formatAmount}
            newvalue={newvalue}
            betvalue={betvalue}
            maxinput={maxWager}
            mininput={minvalue}
          />

          {betslipLength > 1 && (
            <BetslipPayout
              betslipLength={betslipLength}
              samesport={sameSport}
              wager={newvalue}
              multiplier={roundedProduct}
              onPayoutUpdate={handlePayoutUpdate}
            />
          )}

           {betslipLength > 1 && betMaxValue < minMultiplier && ( <Box className="two-btn-flex2" sx={{ mt: "5px", mb: "5px" }}>
          <Typography component="h6">
             The minimum payout for this contest is {minMultiplier?.toFixed(2)}x. 
             Please update your selections to satisfy this requirement.
            </Typography>
           </Box>
           )}

          {/* {userverification === "0" ? (
            ""
          ) : ( */}  
          {/* earlier check was for pending and failed user */}

            <div>
              {betslipLength > 1 && (
                <Box className="bet-buttondiv">
                  {state.auth.isAuthenticated === false ? (
                    <MUIButton
                      variant="contained"
                      color="success"
                      className="top2 mt-2 mb-2"
                      sx={{ width: "100%" }}
                      onClick={gotologin}
                    >
                      <Typography component="span" sx={{ fontSize: "17px" }}>
                        Login
                      </Typography>
                    </MUIButton>
                  ) : (
                    <MUIButton
                      variant="contained"
                      className="top2 mt-3 mb-3"
                      sx={{
                        width: "100%",
                        background:
                          isloading == false ? "#179624" : "lightgreen",
                      }}
                      onClick={betsubmit}
                      disabled={isloading || betMaxValue < minMultiplier}
                    >
                      <Typography component="span" sx={{ fontSize: "16px" }}>
                        {isloading == false ? "Submit entry" : "Loading....."}
                      </Typography>
                    </MUIButton>
                  )}
                </Box>
              )}
            </div>

          {/* // )} */}

          <Toaster />

          <Typography
            variant="body2"
            sx={{
              color: "blue",
              fontSize: "14px",
              mt: "16px",
              display: showerror ? "none" : "",
            }}
          >
            You don't have enough funds in your account to complete your contest
            entry.{` `}
            <Link
              component="button"
              onClick={naviagte3}
              underline="hover"
              sx={{ color: "red", fontSize: "16px" }}
            >
              Click Here
            </Link>
            {` `}
            to add funds to your account.
          </Typography>
        </Box>
      </Box>
      
      {/* Geo/VPN Error Modal */}
      <GeoVpnError 
        show={showGeoVpnError} 
        onClose={() => setShowGeoVpnError(false)} 
      />
    </Box>
  );
};

export default MultiPlayerBetSlip;
